@if (showSupportWidget()) {
  <div class="support-widget d-flex flex-column align-items-end ">
    @if (isSupportWidgetOpen) {
      <div class="support-widget__content udex-mb-24">
        @if (isSapProduct || !isProductDetailsPage) {
          @if (shouldShowChat()) {
            @if (isAgentAvailable) {
              <div
                class="btn btn-link support-widget__tile d-flex align-items-left justify-content-start chat chatNow udex-p-0"
                (click)="openChat()" [attr.data-cy]="'chatNow'">
                <div class="support-widget__image-container d-flex udex-pe-20 udex-pt-20">
                  <img alt="{{'productDetails.chatNow'}} image"
                       src="assets/images/product/support-widget/discussion-2_blue.svg"/>
                </div>
                <div class="support-widget__text-container d-flex flex-column">
                  <a [tabindex]="0"
                     class="ds-heading--xs ds-color--blue ds-link focusable focusable__element">{{
                      'productDetails.chatNow' |
                        cxTranslate
                    }}</a>
                  <p class="ds-fine-print ds-color--black">{{'productDetails.chatNowDescription' | cxTranslate}}</p>
                </div>
              </div>
            } @else {
              <div
                class="btn btn-link support-widget__tile chat chatNow d-flex align-items-center justify-content-start udex-p-0"
                [attr.data-cy]="'chatUnavailable'">
                <div class="support-widget__image-container d-flex udex-pe-20 udex-pt-20">
                  <img alt="{{'productDetails.chatNow'}} image"
                       src="assets/images/product/support-widget/discussion-2_blue.svg"/>
                </div>
                <div class="support-widget__text-container d-flex flex-column">
                  <p class="ds-heading--xs ds-color--black text-decoration-none">{{
                      'productDetails.chatUnavailable' |
                        cxTranslate
                    }}</p>
                </div>
              </div>
            }
          }
          <div (click)="openSupportRequestModal()" (keydown.enter)="openSupportRequestModal()"
               class="btn btn-link support-widget__tile d-flex align-items-left justify-content-start udex p-0"
               [attr.data-cy]="'contactSupport'">
            <div class="support-widget__image-container d-flex udex-pe-20 udex-pt-20">
              <img alt="{{'productDetails.contactSupport'}} image"
                   src="assets/images/product/support-widget/email_blue.svg"/>
            </div>
            <div class="support-widget__text-container d-flex flex-column">

              <a [tabindex]="0"
                 class="ds-heading--xs  ds-color--blue ds-link focusable focusable__element">{{
                  'productDetails.contactSupport'
                    | cxTranslate
                }}</a>
              <span class="ds-fine-print ds-color--black">{{
                  'productDetails.contactSupportDescription' |
                    cxTranslate
                }}</span>
            </div>
          </div>
        } @else {
          @if (useWebComponentLeadForm && partnerTransactionType.actionType === 'popup') {
            <div>
              <div (click)="openEddlModal()" (keydown.enter)="openEddlModal()"
                   [dcpShowFormButton]="{
          name: formDataTrackingService.generateFormName(
            partnerTransactionType.adobeFormType,
            product
          ),
          product: product,
          productId: dcpProductUtilitiesService.getProductId(product),
          actionType: partnerTransactionType?.actionType
         }"
                   class="btn btn-link support-widget__tile d-flex align-items-left justify-content-start udex-p-0"
                   [attr.data-cy]="'askPublisherWebComponent'">
                <ng-container *ngTemplateOutlet="ctaContent"></ng-container>
              </div>
            </div>
          } @else {
            <div (click)="openLeadRfiForm()" (keydown.enter)="openLeadRfiForm()"
                 class="btn btn-link support-widget__tile d-flex align-items-left justify-content-start udex-p-0"
                 [attr.data-cy]="'askPublisher'">
              <ng-container *ngTemplateOutlet="ctaContent"></ng-container>
            </div>
          }
          <ng-template #ctaContent>
            <div class="support-widget__image-container d-flex udex-pe-20 udex-pt-20">
              <img alt="{{'productDetails.askPublisher'}} image"
                   src="assets/images/product/support-widget/discussion-2_blue.svg"/>
            </div>
            <div class="support-widget__text-container d-flex flex-column">
              <a [tabindex]="0"
                 class="ds-heading--xs my-3 ds-color--blue ds-link focusable focusable__element">{{
                  'productDetails.askPublisher'
                    | cxTranslate
                }}</a>
              <span
                class="ds-fine-print ds-color--black">{{'productDetails.askPublisherDescription' | cxTranslate}}</span>
            </div>
          </ng-template>
          <div (click)="openSupportRequestModal()" (keydown.enter)="openSupportRequestModal()"
               class="btn btn-link support-widget__tile d-flex align-items-left justify-content-start udex p-0"
               [attr.data-cy]="'askSapStore'">
            <div class="support-widget__image-container d-flex udex-pe-20 udex-pt-20">
              <img alt="{{'productDetails.contactSupport'}} image"
                   src="assets/images/product/support-widget/email_blue.svg"/>
            </div>
            <div class="support-widget__text-container d-flex flex-column">

              <a [tabindex]="0"
                 class="ds-heading--xs  ds-color--blue ds-link focusable focusable__element">{{
                  'productDetails.contactSupport' |
                    cxTranslate
                }}</a>
              <span
                class="ds-fine-print ds-color--black">{{'productDetails.contactSupportDescription' | cxTranslate}}</span>
            </div>
          </div>
        }

      </div>
    }



    <udex-button size="Large" class="support-widget__btn" (click)="toggleSupportWidget()" icon="sap-icon://discussion-2"
                 [active]="isSupportWidgetOpen" [attr.data-cy]="'support-widget-button'">
      <span class="button-text">{{'productDetails.contactUs' | cxTranslate}}</span>
    </udex-button>
  </div>


}

